"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Transforms a color string like `rgb(0,0,0)` to a color string in hex syntax like `#000000`
 */
function rgb2Hex(s) {
    //@ts-ignore
    return s.match(/[0-9]+/g).reduce(function (a, b) { return a + (b | 256).toString(16).slice(1); }, '#').toString(16);
}
exports.rgb2Hex = rgb2Hex;
//# sourceMappingURL=color.js.map